export default __webpack_public_path__ + "static/media/3.b9107a6b.jpeg";